import { Box, MenuItem, TextField, Theme, Typography } from "@mui/material";
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { commonTextFieldProps } from "../../textfield";
import { UserSchema } from "../api/schema";
import { initialUserData, userInvitationOptions, UserInvitationType } from "../api/types";
import useUserInvitationStore from "../api/store";
import useUserInvStore from "../api/store";

interface IQueryForm {
    control: Control<UserSchema, any>
    errors: FieldErrors<UserSchema>
    setValue: UseFormSetValue<UserSchema>
    watch: UseFormWatch<UserSchema>
    disabled: boolean
}

export const QueryForm: React.FC<IQueryForm> = ({
    control,
    errors,
    setValue,
    watch,
    disabled
}) => {
    const { setQueryData } = useUserInvStore();
    const { setSelectedUser } = useUserInvitationStore();


    return <Box sx={{
        width: "100%",
    }}>
        <Box sx={{ mt: "10px", mb: "15px" }} >
            <Controller
                name="type"
                control={control}
                defaultValue={UserInvitationType.Email} // Ensure defaultValue is provided
                render={({ field }) => (
                    <TextField
                        id="type-select-textfield"
                        {...field}
                        fullWidth
                        select
                        sx={commonTextFieldProps}
                        value={field.value ?? UserInvitationType.Email} // Ensure value is never undefined
                        onChange={(e) => {
                            field.onChange(e.target.value);
                            setQueryData(initialUserData);
                            setValue("email", "");
                            setValue("firstName", "");
                            setValue("lastName", "");
                            setSelectedUser(undefined);
                        }}
                        slotProps={{
                            select: {
                                SelectDisplayProps: { "data-testid": "type-select-textfield" } as any,
                            },
                            htmlInput: {
                                MenuProps: {
                                    MenuListProps: {
                                        sx: (theme: Theme) => ({
                                            border: `1px solid ${theme.palette.text.secondary}`,
                                            borderRadius: "5px",
                                        }),
                                    },
                                },
                            },
                        }}
                    >
                        {Object.values(userInvitationOptions).map((option) => (
                            <MenuItem id={option.id} data-testid={option.id} key={option.value} value={option.value}>
                                <Typography color="primary.main">{option.label}</Typography>
                            </MenuItem>
                        ))}
                    </TextField>
                )}
            />
        </Box>

        {watch("type") === UserInvitationType.Email && <Box  >
            <Controller
                name="email"
                control={control}
                render={({ field }) => (
                    <TextField
                        id="email-textfield"
                        {...field}
                        fullWidth
                        sx={commonTextFieldProps}
                        disabled={disabled}
                        variant="outlined"
                        label="Email"
                        autoComplete="off"
                        slotProps={{ htmlInput: { "data-testid": "email-textfield" } }}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />
                )}
            />
        </Box>}

        {watch("type") === UserInvitationType.UserFullname && <Box sx={{
            width: "100%",
            display: "flex",
            flexDirection: {mobile:"column",laptop:"row"},
            gap: 2
        }}>

            <Box sx={{ width: "100%" }}>
                <Controller
                    name="lastName"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            id="last-name-textfield"
                            {...field}
                            value={field.value}
                            fullWidth
                            sx={commonTextFieldProps}
                            disabled={disabled}
                            variant="outlined"
                            label="Last Name"
                            autoComplete="off"
                            slotProps={{ htmlInput: { "data-testid": "last-name-textfield" } }}
                            error={!!errors.lastName}
                            helperText={errors.lastName?.message}
                        />
                    )}
                />
            </Box>

            <Box sx={{ width: "100%"}} >
                <Controller
                    name="firstName"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            id="first-name-textfield"
                            {...field}
                            value={field.value}
                            fullWidth
                            sx={commonTextFieldProps}
                            disabled={disabled}
                            variant="outlined"
                            label="First Name"
                            autoComplete="off"
                            slotProps={{ htmlInput: { "data-testid": "first-name-textfield" } }}
                            error={!!errors.firstName}
                            helperText={errors.firstName?.message}
                        />
                    )}
                />
            </Box>
        </Box>}
    </Box>;
}